var _style, _g, _polygon, _path, _path2, _path3, _rect, _path4, _path5, _polygon2, _polygon3, _path6, _circle, _circle2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 243.1",
    style: {
      enableBackground: "new 0 0 380 243.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F48120;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:url(#XMLID_3_);}\r\n\t.st4{opacity:0.65;fill:url(#XMLID_4_);enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_"
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_428_",
    className: "st0",
    points: "1.3,1.5 378.6,1.5 378.6,241.7 1.4,241.7  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "st1",
    d: "M377.3,135.1c0,0-103.1,72.7-291.9,105.3h291.9V135.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M378.6,0.1H0v243h380V0h-1.4V0.1z M377.3,2.8c0,2.7,0,234.8,0,237.5c-2.7,0-371.8,0-374.5,0 c0-2.7,0-234.8,0-237.5C5.5,2.8,374.5,2.8,377.3,2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,74.4H17.5v55h15.7c8.3,0,14.3-2,19.6-6.3c6.3-5.2,10-13,10-21.1C62.7,85.7,50.6,74.4,33.2,74.4z  M45.8,115.8c-3.4,3-7.7,4.4-14.7,4.4h-2.9V83.8h2.9c6.9,0,11.1,1.2,14.7,4.4c3.7,3.3,5.9,8.4,5.9,13.7 C51.7,107.2,49.5,112.5,45.8,115.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_422_",
    x: 67.7,
    y: 74.4,
    className: "st2",
    width: 10.7,
    height: 55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st2",
    d: "M104.6,95.5c-6.4-2.4-8.3-4-8.3-6.9c0-3.5,3.4-6.1,8-6.1c3.2,0,5.9,1.3,8.6,4.5l5.6-7.3 c-4.6-4-10.1-6.1-16.2-6.1c-9.7,0-17.2,6.8-17.2,15.8c0,7.6,3.5,11.5,13.5,15.1c4.2,1.5,6.3,2.5,7.4,3.1c2.1,1.4,3.2,3.4,3.2,5.7 c0,4.5-3.5,7.8-8.3,7.8c-5.1,0-9.2-2.6-11.7-7.3l-6.9,6.7c4.9,7.3,10.9,10.5,19,10.5c11.1,0,19-7.4,19-18.1 C120.5,104,116.8,100,104.6,95.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st2",
    d: "M123.8,102c0,16.2,12.7,28.7,29,28.7c4.6,0,8.6-0.9,13.4-3.2v-12.6c-4.3,4.3-8.1,6-12.9,6 c-10.8,0-18.5-7.8-18.5-19c0-10.6,7.9-18.9,18-18.9c5.1,0,9,1.8,13.4,6.2V76.6c-4.7-2.4-8.6-3.4-13.2-3.4 C136.9,73.2,123.8,86,123.8,102z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_419_",
    className: "st2",
    points: "251.4,111.4 236.7,74.4 225,74.4 248.3,130.8 254.1,130.8 277.8,74.4 266.2,74.4  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_418_",
    className: "st2",
    points: "282.7,129.4 313.1,129.4 313.1,120.1 293.4,120.1 293.4,105.3 312.4,105.3 312.4,96  293.4,96 293.4,83.8 313.1,83.8 313.1,74.4 282.7,74.4  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M355.6,90.7c0-10.3-7.1-16.2-19.5-16.2h-15.9v55h10.7v-22.1h1.4l14.8,22.1h13.2L343,106.3 C351.1,104.6,355.6,99.1,355.6,90.7z M334,99.8h-3.1V83.1h3.3c6.7,0,10.3,2.8,10.3,8.2C344.5,96.8,340.9,99.8,334,99.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.0753,
    y1: 417.547,
    x2: 193.8214,
    y2: 385.8353,
    gradientTransform: "matrix(1 0 0 1 0 -292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F89F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#F79A20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#F68D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#F48120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37521"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_415_",
    className: "st3",
    cx: 199.1,
    cy: 102.1,
    r: 29.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.8777,
    y1: 417.1202,
    x2: 181.276,
    y2: 359.262,
    gradientTransform: "matrix(1 0 0 1 0 -292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    style: {
      stopColor: "#E16F27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#D4602C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#D05B2E"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_414_",
    className: "st4",
    cx: 199.1,
    cy: 102.1,
    r: 29.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.4,76.5c0-1-0.7-1.5-1.8-1.5H359v4.8h1.2v-1.9l1.4,1.9h1.4l-1.6-2C362,77.7,362.4,77.2,362.4,76.5z  M360.4,77.2h-0.2v-1.3h0.2c0.6,0,0.9,0.2,0.9,0.6C361.3,77,361,77.2,360.4,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.8,73.2c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2S363.1,73.2,360.8,73.2z  M360.8,80.9c-1.8,0-3.4-1.5-3.4-3.5c0-1.9,1.5-3.5,3.4-3.5c1.8,0,3.3,1.6,3.3,3.5C364.1,79.3,362.6,80.9,360.8,80.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.1b3e1dc3477e0cec08419dd6e5155619.svg";
export { ForwardRef as ReactComponent };